import {
  getWebInstrumentations,
  initializeFaro,
  type EventAttributes,
  type Faro,
} from '@grafana/faro-web-sdk';

const isAnalyticsEnabled =
  import.meta.env.PROD || import.meta.env.VITE_ENABLE_ANALYTICS === 'true';

const FARO_URL = import.meta.env.VITE_FARO_URL as string | undefined;
const FARO_APP_NAME = (import.meta.env.VITE_FARO_APP_NAME as string | undefined) ?? 'crowdfpl-web';
const FARO_APP_VERSION = (import.meta.env.VITE_FARO_APP_VERSION as string | undefined) ?? '0.0.0';
const FARO_API_KEY = import.meta.env.VITE_FARO_API_KEY as string | undefined;

let faroInstance: Faro | null = null;

if (FARO_URL && isAnalyticsEnabled) {
  faroInstance = initializeFaro({
    url: FARO_URL,
    ...(FARO_API_KEY ? { apiKey: FARO_API_KEY } : {}),
    app: {
      name: FARO_APP_NAME,
      version: FARO_APP_VERSION,
    },
    instrumentations: [...getWebInstrumentations({ captureConsole: false })],
  });
  console.log('✅ Grafana Faro RUM initialized');
} else {
  console.log('⚠️ Grafana Faro RUM disabled (no VITE_FARO_URL or analytics off)');
}

export const faro = faroInstance;

export function trackFaroEvent(name: string, attributes?: EventAttributes, domain?: string): void {
  if (!faroInstance) return;
  try {
    faroInstance.api.pushEvent(name, attributes, domain);
  } catch (error) {
    console.error(error);
  }
}
